export const technical = {
  systems: {
    title: "Tehnilised Süsteemid",
    hvac: "HVAC",
    electrical: "Elektrisüsteem",
    plumbing: "Torusüsteem",
    fire: "Tulekaitse",
    security: "Turvalisus",
    automation: "Hooneautomaatika",
    elevator: "Lift",
    communication: "Side",
  },
  status: {
    operational: "Töötab",
    maintenance: "Hoolduses",
    repair: "Vajab parandamist",
    replacement: "Vajab asendamist",
  },
  data: {
    title: "Tehnilised Andmed",
    noDataAvailable: "Tehnilised andmed puuduvad",
    createRecord: "Loo tehniliste andmete kirje",
    grossArea: "Brutopindala",
    leasableArea: "Üüritav pindala",
    buildingHeight: "Hoone kõrgus",
    plotSize: "Krundi suurus",
    builtUpPercentage: "Hoonestuse protsent",
    floorLoadCapacity: "Põranda kandevõime",
    buildingFootprint: "Hoone jalajälg",
    siteCoverageRatio: "Krundi täisehituse protsent",
    floorAreaRatio: "Korruste pindala suhe",
    placeholder: "Määramata",
    edit: "Muuda",
    save: "Salvesta",
    cancel: "Tühista",
    saving: "Salvestamine...",
    successTitle: "Õnnestus",
    successDesc: "Tehnilised andmed edukalt uuendatud",
    errorTitle: "Viga",
    errorDesc: "Tehniliste andmete uuendamine ebaõnnestus",
    grossAreaError: "Brutopindala ei saa olla väiksem kui üüritav pindala",
    netAreaError: "Brutopindala peab olema suurem kui netopindala",
    leasableAreaRatioWarning:
      "Üüritava pindala suhe brutopindalasse on alla 80%, võib olla kasutamata ruume lisatulu teenimiseks",
    sources: {
      database: "Andmebaas",
      documents: "Dokumendid",
      mockData: "Testandmed",
      userInput: "Kasutaja sisend",
    },
    lastUpdate: "Viimane Uuendus",
    nextMaintenance: "Järgmine Hooldus",
    efficiency: "Efektiivsus",
    performance: "Jõudlus",
  },
  fireSafety: {
    title: "Tuleohutus",
    description: "Hoone tuleohutuse andmed",
    noDataAvailable: "Tuleohutuse andmed puuduvad",
    creatingRecord: "Tuleohutuse kirje loomine...",
    sprinklerSystem: "Sprinklersüsteem",
    fireAlarmSystem: "Tuletõrjehäire",
    emergencyLighting: "Avariivalgustus",
    evacuationRoutes: "Evakuatsiooniteed",
    fireExtinguishers: "Tulekustutid",
    smokeDetectors: "Suitsuandurid",
    fireDoors: "Tuletõkkeuksed",
    emergencyExits: "Varuväljapääsud",
    assemblyPoints: "Kogunemispunktid",
    scheduleInspection: "Planeeri ülevaatus",
  },
};
